import React, { useState, useEffect } from 'react';
import './PublicSignUp.css';
import { useParams } from 'react-router-dom';



export default function PublicSignUp() {
  const [photoFile, setPhotoFile] = useState(null);
  const [showAddOnsModal, setShowAddOnsModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [storeInfoParsed, setStoreInfoParsed] = useState({ storeName: '', storeNumber: '' });
  const { storeInfo } = useParams();


  const [formData, setFormData] = useState({
    storeNumber: '',
    storeName: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '', 
    state: '',
    zip: '',
    phone: '',
    email: '',
    accessType: '',
    keyFobCode: '',
    membershipDuration: '',
    membershipLevel: '',
    photo: null,
    honeypot: '',
    addOn1Name: '',
    addOn1Email: '',
    addOn1Phone: '',
    addOn1Access: 'Phone App',
    addOn1FobCode: '',
    addOn2Name: '',
    addOn2Email: '',
    addOn2Phone: '',
    addOn2Access: 'Phone App',
    addOn2FobCode: '',
  });


useEffect(() => {
  console.log("📦 Raw storeInfo from URL:", storeInfo); // ✅ Move this outside the if-block

  if (storeInfo && storeInfo.includes('.')) {
    const [storeNameRaw, storeNumberRaw] = storeInfo.split('.');
    const storeName = decodeURIComponent(storeNameRaw);
    const storeNumber = storeNumberRaw;

    setStoreInfoParsed({ storeName, storeNumber });

    setFormData(prev => ({
      ...prev,
      storeName,
      storeNumber
    }));

    console.log("✅ Parsed store info:", storeName, storeNumber); // ✅ Useful for debugging
  } else {
    console.warn("⚠️ Invalid store URL format. Use /StoreName.10");
  }
}, [storeInfo]);




  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file' && files.length > 0) {
      setPhotoFile(files[0]);
    }

    setFormData(prev => ({
      ...prev,
      [name]: type === 'file' ? '' : value,
    }));

    if (name === "membershipLevel") {
      setShowAddOnsModal(value === "Family");
    }
  };

  const uploadPhotoToAzure = async (recordId) => {
  if (!photoFile) return '';

  try {
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(photoFile);
    });

    const res = await fetch('https://rgs-a.azurewebsites.net/api/Master_Function', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        target: 'Upload_ID_Save_ID',
        payload: {
          id: recordId,
          storeNumber: formData.storeNumber,
          fileName: `photo-${Date.now()}.jpg`,
          fileContent: base64
        }
      }),
    });

    if (!res.ok) throw new Error('Upload failed');
    const data = await res.json();
    return data.url;
  } catch (err) {
    console.error('Image upload failed', err);
    return '';
  }
};


//    reader.readAsDataURL(photoFile);
//  });
//};


  const handleSubmit = async (e) => {
  e.preventDefault();

  if (formData.honeypot) {
    alert("Bot detected.");
    return;
  }
    setIsSubmitting(true);

    console.log("📤 Submitting with storeName:", formData.storeName);
    console.log("📤 Submitting with storeNumber:", formData.storeNumber);


  try {
    // 1. Submit main form (without image first)
    const formRes = await fetch('https://rgs-a.azurewebsites.net/api/Master_Function', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        target: 'MasterSignUp',
        payload: {
              ...formData,
              storeName: storeInfoParsed.storeName,
              storeNumber: storeInfoParsed.storeNumber,
              approval: 'Pending',
              addOns: [
            {
              fullName: formData.addOn1Name,
              email: formData.addOn1Email,
              phoneNumber: formData.addOn1Phone,
              accessType: formData.addOn1Access,
              keyFobCode: formData.addOn1FobCode
            },
            {
              fullName: formData.addOn2Name,
              email: formData.addOn2Email,
              phoneNumber: formData.addOn2Phone,
              accessType: formData.addOn2Access,
              keyFobCode: formData.addOn2FobCode
            }
          ]
        }
      }),
    });

    if (!formRes.ok) throw new Error('Form submission failed');

    const responseData = await formRes.json();
    const createdId = responseData?.id;

    if (!createdId) {
      alert("Error: ID not returned from SharePoint.");
      return;
    }

    // ✅ Now upload the image only after ID is available
    if (photoFile) {
      await uploadPhotoToAzure(createdId);
    }

console.log("MasterSignUp response:", responseData);


    alert('Form submitted successfully!');
  } catch (err) {
    console.error(err);
    alert('Submission failed. Please try again.');
  }finally {
    setIsSubmitting(false);
  }
};


  return (
    <>
      <form className="container" onSubmit={handleSubmit}>
        <h1 className="header">Membership Sign Up</h1>

        <div className="cardSection">
          <div className="card">
            <input className="input" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required/>
            <input className="input" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required/>
            <input className="input" name="address" placeholder="Mailing Address" value={formData.address} onChange={handleChange} required/>
            <input className="input" name="city" placeholder="City" value={formData.city} onChange={handleChange} required/>
            <input className="input" name="state" placeholder="State" value={formData.state} onChange={handleChange} required/>
            <input className="input" name="zip" placeholder="Zip" value={formData.zip} onChange={handleChange} required/>
            <input className="input" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required/>
            <input className="input" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required/>

            <label className="label">Access Type</label>
            <select className="input" name="accessType" value={formData.accessType} onChange={handleChange}required>
              <option value="">Select Access Type</option>
              <option value="Phone App">Phone App</option>
              <option value="Key Fob">Key Fob</option>
            </select>

            {formData.accessType === 'Key Fob' && (
              <input className="input" name="keyFobCode" placeholder="Fob Code" value={formData.keyFobCode} onChange={handleChange} />
            )}

            <label className="label">Membership Duration</label>
            <select className="input" name="membershipDuration" value={formData.membershipDuration} onChange={handleChange}required>
              <option value="">Select Duration</option>
              <option value="3 Month">3 Month</option>
              <option value="6 Month">6 Month</option>
              <option value="1 Year">1 Year</option>
            </select>

            <label className="label">Membership Level</label>
            <select className="input" name="membershipLevel" value={formData.membershipLevel} onChange={handleChange}required>
              <option value="">Select Level</option>
              <option value="Single">Single</option>
              <option value="Family">Family</option>
            </select>

            <label className="label">Upload Photo ID</label>
            <input className="input" type="file" name="photo" accept="image/*" onChange={handleChange} required />
          </div>
        </div>

        <input className="honeypot" name="honeypot" value={formData.honeypot} onChange={handleChange} autoComplete="off" tabIndex="-1" />

        {isSubmitting ? (
           <div className="spinner"></div>
              ) : (
                <button className="submitButton" type="submit">Submit</button>
              )}
      </form>

      {showAddOnsModal && (
        <div className="modalOverlay">
          <div className="modalContent">
            <h2 className="header">Add-On Members</h2>

            <div className="addonTitle">First Add-On</div>
            <div className="addonCard">
              <div className="addonField">Name: <input name="addOn1Name" value={formData.addOn1Name} onChange={handleChange} className="input" /></div>
              <div className="addonField">Email: <input name="addOn1Email" value={formData.addOn1Email} onChange={handleChange} className="input" /></div>
              <div className="addonField">Phone: <input name="addOn1Phone" value={formData.addOn1Phone} onChange={handleChange} className="input" /></div>
              <div className="addonField">Access Type:
                <select name="addOn1Access" value={formData.addOn1Access} onChange={handleChange} className="input">
                  <option value="Phone App">Phone App</option>
                  <option value="Key Fob">Key Fob</option>
                </select>
              </div>
              {formData.addOn1Access === "Key Fob" && (
                <div className="addonField">Fob Code: <input name="addOn1FobCode" value={formData.addOn1FobCode} onChange={handleChange} className="input" /></div>
              )}
            </div>

            <div className="addonTitle">Second Add-On</div>
            <div className="addonCard">
              <div className="addonField">Name: <input name="addOn2Name" value={formData.addOn2Name} onChange={handleChange} className="input" /></div>
              <div className="addonField">Email: <input name="addOn2Email" value={formData.addOn2Email} onChange={handleChange} className="input" /></div>
              <div className="addonField">Phone: <input name="addOn2Phone" value={formData.addOn2Phone} onChange={handleChange} className="input" /></div>
              <div className="addonField">Access Type:
                <select name="addOn2Access" value={formData.addOn2Access} onChange={handleChange} className="input">
                  <option value="Phone App">Phone App</option>
                  <option value="Key Fob">Key Fob</option>
                </select>
              </div>
              {formData.addOn2Access === "Key Fob" && (
                <div className="addonField">Fob Code: <input name="addOn2FobCode" value={formData.addOn2FobCode} onChange={handleChange} className="input" /></div>
              )}
            </div>

            <div className="modalActions">
              <button type="button" className="submitButton" onClick={() => setShowAddOnsModal(false)}>Save Add-Ons</button>
              <button type="button" className="secondaryButton" onClick={() => setShowAddOnsModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
